export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

export const ONESIGNAL_APPID = "39ffbde4-3fa9-4478-a629-2d87ae9bc2db";
export const QR_DOWNLOAD_URL = (id, eventId, _id) =>
    `https://app.gleefolder.com/event-management/event-details/${eventId}/create?_qr=${id}&_id=${_id}`;
